import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, QueryList, Input, SimpleChanges } from '@angular/core';
import { StaffService } from '../services/staff/staff.service';
import { Observable } from 'rxjs';

import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatDialog } from '@angular/material';
import { AddStaffModalComponent } from './add-staff-modal/add-staff-modal.component';
import { EditStaffModalComponent } from './edit-staff-modal/edit-staff-modal.component';
import { FilterService } from "../services/filter.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { MpService } from '../services/staff/mp.service';
import * as _ from 'lodash'
import { UtilityService } from './../services/utility.service'
import { CompetencyDetailModalComponent } from '../competency/competency-detail-modal/competency-detail-modal.component';
import { config } from '../_models/userCompetency'
import { NewFileModalComponent } from '../files/new-file-modal/new-file-modal.component';
import { userRolesList } from '../_models/staticArray'
import { DeleteConfirmModalComponent } from '../commons/delete-confirm-modal/delete-confirm-modal.component';
import { LocationStrategy, Location } from '@angular/common';
@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
  @Input('_isStaffView') _isStaffView
  @ViewChildren('myCheckbox') private myCheckboxes: QueryList<any>;
  users = []
  loading: Boolean;
  instructors: any = [];
  staff = [];
  length;
  view;
  pageSizeOptions: number[] = [25, 50, 100];
  displayedColumns: string[] = ['name', 'dateOfJoining', 'role', 'sponsertype', 'competency', 'actions'];
  displayedPendingUsersColumns: string[] = ['fullname', 'email', 'submission', 'actions'];
  // displayedColumns: string[] = ['name', 'dateOfJoining', 'actions'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  searchText;
  afterFilter: any;
  filterActive: Boolean = false;
  selectedUser = 'All';
  noDataMsg = {
    title: "No Staff!",
    data: "You have not yet added any staff members"
  }
  noPendingDataMsg = {
    title: "No Pending Users!",
    data: "No users are waiting for approval"
  }
  staffCopy: any;
  module: any;
  isPending = false
  pendingUserList = []
  pendingUserListCopy = []
  category = config.list
  categoryTitle = []
  userRoleList = userRolesList
  title = [];
  array4 = ['']
  eventCategory
  eventUser
  eventRole
  systemDate
  multipleStaffArchive = []
  archiveStaffList = []
  archiveStaffListCopy = []
  showArchived = false
  selectedTab = 0
  _isDisplay = false
  pendingUserData
  _staffView
  isSpinnerId
  isSpinner: boolean = false

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator, { static: false }) set pendingUsers(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public _staffService: StaffService,
    public _mpService: MpService,
    public dialog: MatDialog,
    public _filter: FilterService,
    public _snackBar: MatSnackBar,
    public _utilityService: UtilityService,
    public _cd: ChangeDetectorRef,
    private location: Location,
    private locationStrategy: LocationStrategy,
  ) {
    this.instructors = [];
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.loading = true;
    this.getStaff()
    this.getPendingUsers()
    this.module = JSON.parse(localStorage.getItem('module'))
    if (this.module.isTrainingJob && this.module.isMpJob) {
      this.users = ['trainer', 'mp', 'IQA', 'Others']
    } else if (this.module.isTrainingJob && !this.module.isMpJob) {
      this.users = ['trainer', 'IQA', 'Others']
    }
    //  else {
    //   this.users = ['mp']
    // }
    console.log('Function is calling');

    if (this.router.url.includes('/dashboard')) {
      this.view = true;
      console.log("VIEW VALUE IS", this.view)
      $('#paginator').addClass('col-lg-6, col-md-6')
      $('#staff-table-height').addClass('table-height');
    }
    else {
      $('#paginator').addClass('col-lg-4, col-md-4')
    }
    this.activatedRoute.queryParams.subscribe(params => {
      console.log("params in admin time sheet page", params);
      if (params.currentTab) {
        this.selectedTab = params.currentTab
      } else {
        this.updateQueryParams({ currentTab: this.selectedTab })
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES OF TAB", changes)
    if (changes._isStaffView && changes._isStaffView.currentValue) {
      this._staffView = changes._isStaffView.currentValue;
      if (this._staffView === 'staff') {
        console.log("AFTER APPROVE USER DATA", this.staff)
        this.getStaff()
        // this.updateData(this.staff)
        // this._cd.detectChanges()
      }
      if (this._staffView === 'pendingStaff') {
        // this.getPendingUsers(true)
        this.updateData(this.pendingUserList)
      }
    }


  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.paginator._intl) {
      const paginatorIntl = this.paginator._intl;
      paginatorIntl.nextPageLabel = '';
      paginatorIntl.previousPageLabel = '';
    }

  }


  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;

    if (this.selectedTab === 1) {
      if (searchText === '') {
        this.updateData(this.pendingUserList);
        this.filterActive = false;
      }
      let pendingList = this.pendingUserList
      let filteredIns = this._filter.staffFilterService(searchText, pendingList, ['fullName']);
      console.log("FILTERED", filteredIns)
      this.updateData(filteredIns);
      if (filteredIns.length <= 0) {
        this.afterFilter = {
          title: "No Pending Users!",
          data: "Sorry, no member matched your search"
        }
      }

    }
    else {
      let staffList = this.showArchived ? this.archiveStaffList : this.staff
      if (searchText === '') {
        this.updateData(this.staff);
        this.filterActive = false;
      }
      let filteredIns = this._filter.staffFilterService(searchText, staffList, ['name', 'role', 'title', 'category', 'alias', 'sentinelNumber']);
      this.updateData(filteredIns);
      if (filteredIns.length <= 0) {
        this.afterFilter = {
          title: "No Staff!",
          data: "Sorry, no member matched your search"
        }
      }
    }


  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }

  showFormattedDate(date) {
    let d = new Date(date);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  }

  getBadgeColor(item) {
    switch (item) {
      case 'trainer':
        return 'trainer'
        break;
      case 'mp':
        return 'mp'
        break;

      case 'IQA':
        return 'iqa'
        break;

      case 'operative':
        return 'operative'
        break;

      case 'assetManager':
        return 'assetManager'
        break;

      case 'manager':
        return 'manager'
        break;

      default:
        break;
    }
  }

  selectCategory(event) {
    console.log("event when category is selected", event);
    let element = this.category.find((x) => x.viewValue === event)
    if (event) {
      this.eventCategory = element.viewValue
      this.categoryTitle = element.value
    }
    else {
      // this.afterFilter = null
      // this.filterActive = true
      this.categoryTitle = []
      this.eventCategory = ''
      // if (!this.eventCategory && !this.eventUser && !this.eventRole && !this.title.length) {
      //   this.updateData(this.staff)
      // }
    }

  }

  selectTitle(event) {
    console.log("here is selected title ==>", event)

    if (event) {
      this.title = event
    } else {
      this.title = []
      // this.afterFilter = null
      // this.filterActive = true
      // if (!this.eventCategory && !this.eventUser && !this.eventRole && !this.title.length) {
      //   this.updateData(this.staff)
      // }
    }
  }

  selectUser(event) {
    console.log("here is the select user", event)
    if (event) {
      this.eventUser = event
    } else {
      this.eventUser = ''
      // this.afterFilter = null
      // this.filterActive = true
      // if (!this.eventCategory && !this.eventUser && !this.eventRole && !this.title.length) {
      //   this.updateData(this.staff)
      // }
    }
  }

  selectRole(event) {
    console.log("event when role is selected", event);
    if (event) {
      this.eventRole = event
    } else {
      this.eventRole = ''
      // this.afterFilter = null
      // this.filterActive = true
      // if (!this.eventCategory && !this.eventUser && !this.eventRole && !this.title.length) {
      //   this.updateData(this.staff)
      // }
    }
  }

  filterOnGo() {
    console.log("Click on Go====>");
    console.log("Category===>", this.eventCategory, "=====", this.eventUser, "=======", this.eventRole, "========", this.title);
    // this.array4.push(this.role)
    let finalStaffArray = []
    let tempstaff = this.staff
    let category = this.eventCategory
    let eventUser = this.eventUser
    let eventRole = this.eventRole
    let compTitle = this.title

    if (!this.eventCategory && !this.eventUser && !this.eventRole && !this.title.length) {
      this.updateData(this.staff)
      this.afterFilter = null
      this.filterActive = true
    }
    else {

      finalStaffArray = this.staff.filter(function (item, index) {
        // console.log("here is the array  =====>", item);
        let result
        if (category && compTitle && compTitle.length) {
          result = item.competencies.filter(comp => comp.category == category && compTitle.includes(comp.title))
        }
        else {
          result = item.competencies.filter(comp => comp.category == category)
        }

        if (result.length && category) {
          return true
        }
        else if (item.name == eventUser && eventUser) {
          return true
        }

        else if (item.userId.userRole.includes(eventRole) && eventRole) {
          return true
        }

      });

      console.log('here is the finall Staff ', finalStaffArray)

      if (!finalStaffArray.length) {
        this.filterActive = true
        this.afterFilter = {
          title: "No Staff!",
          data: "Sorry, no member matched your search"
        }
        this.updateData([])
      }
      else {
        this.filterActive = true
        this.afterFilter = null
        this.updateData(finalStaffArray)
      }

    }


  }


  // MODALS
  addStaffModal() {
    let data = {
      date: this.systemDate
    }
    let addedInstructor = this.openDialog(AddStaffModalComponent, data).subscribe((staff) => {
      if (staff == undefined) return;
      console.log("Staff added in controller = ", staff);
      this.getStaff();
      // this.staff.push(staff);
      this.openSnackBar("User added successfully!", "Ok");
      // this.updateData(this.staff);
    }, err => {
      return this.openSnackBar("User could not be added!", "Ok");
    });
  }


  uploadFileModel() {
    console.log("open file model");
    let obj = {
      isCreate: true
    }

    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);

        if (fileQueue && fileQueue.instructors && fileQueue.instructors.length) {
          this.staff = fileQueue.instructors
          this.staffCopy = fileQueue.instructors
          this.updateData(this.staff)
          this._cd.detectChanges()
          // this._utilityService.handleSnackBar({ msg: "User Created successfully!", button: "OK" })
          console.log("hello recive staff here", this.staff)
        }
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });


  }


  uploadCompetency() {
    let obj = {
      isCompetency: true
    }

    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue && fileQueue.instructors && fileQueue.instructors.length) {
          this.staff = fileQueue.instructors
          this.updateData(this.staff)
          // this._utilityService.handleSnackBar({ msg: "Competencies Created successfully!", button: "OK" })
          console.log("hello recive staff here", this.staff)
        }
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }


  editStaffModal(index, data) {
    this.openDialog(EditStaffModalComponent, data).subscribe((instructor) => {
      console.log("DIALOG CLOSED", instructor)
      // Handle Undefined

      if (!instructor) { return }

      // Handle Error

      if (instructor && instructor.result == "err") return this.openSnackBar("User could not be edited!", "Ok");

      // EDIT HANDLE
      if (instructor && instructor.action == 'edit') {
        console.log("HANDLING EDIT SUCCESS", instructor.data);
        data = instructor.data;
        let index = this.instructors.findIndex(function (i) {
          return i._id === data._id;
        })
        this.instructors[index] = instructor.data;
        this.handleSnackBar({ msg: "User edited successfully!", button: "Ok" });
      }
      // DELETE HANDLE
      else if (instructor && instructor.action == 'delete') {
        console.log("Deleted ", instructor);
        this.instructors.splice(this.instructors.findIndex(function (i) {
          return i._id === data._id;
        }), 1);
        this.handleSnackBar({ msg: "User deleted successfully!", button: "Ok" });
      }
      this.updateData(this.instructors);

    });
  }

  /*For simple user */
  selectedUserChanged() {
    this.staff = this.staffCopy
    console.log('USER CHANGED', this.selectedUser);
    if (this.selectedUser == 'All') {
      // this.staff = this.staffCopy
      this.updateData(this.staff)
    }
    else if (this.selectedUser == 'Trainer') {
      console.log('TRAINER')
      let sortedList = this.staff.filter(
        a => (a.userId.userRole.some(b => (b == 'trainer'))))
      console.log("sortedList", sortedList)
      this.staff = sortedList

      this.updateData(this.staff)
    }

    else {
      let sortedList = this.staff.filter(
        a => (a.userId.userRole.some(b => (b == 'mp'))))
      this.staff = sortedList

      this.updateData(this.staff)
    }

  }

  filterOnRole(event) {

    console.log("value of selected event", event);
    this.filterActive = false
    let finalList = event.value
    let uniqArray
    if (finalList && finalList.length) {
      this.staff = this.staffCopy
      let sortedList
      let otherList
      let selected = Object.create(null);
      finalList.forEach(a => selected[a] = true);
      console.log("selected role value", selected);

      sortedList = this.staffCopy.filter(
        a => (a.userId.userRole.some(b => selected[b]))
      )
      console.log("what is the sorted list array", sortedList);
      if (finalList.includes('Others')) {
        otherList = this.staffCopy.filter((a) => {
          if (a.userId.userRole && !a.userId.userRole.length) {
            return a
          }
        })
      }
      console.log("otherlist array", otherList);
      if (otherList == undefined) {
        uniqArray = sortedList
      } else {
        uniqArray = sortedList.concat(otherList)
      }

      // console.log("what is the uniq array to display", uniqArray);
      console.log("call this for filter", uniqArray);
      if (uniqArray && uniqArray.length) {
        this.staff = uniqArray
        this.updateData(this.staff)
      } else {
        this.staff = uniqArray
        this.updateData(this.staff)
        this.filterActive = true
        this.afterFilter = {
          title: "No Users!",
          data: "No users with matched search text found!"
        }
      }
    } else {
      this.staff = this.staffCopy
      this.updateData(this.staff)
    }
  }

  displayRole(user) {
    if (user == 'trainer') {
      return 'Trainer'
    }
    if (user == 'mp') {
      return 'Medical Practitioner'
    } else {
      return user
    }
  }


  statusChanged(event) {
    console.log("event", event.value);
    let temp = [];
    let uniqueArray = []
    if (event.value.length) {

      event.value.forEach(singleValue => {
        console.log("this.allSessionsCopy", this.staffCopy);

        let sortedList = this.staffCopy.filter((a) => {
          if (a.userId.userRole.length > 0) {
            return a.userId.userRole.some(function (x) {

              if (x.toString() == singleValue.toLowerCase().toString()) {
                return x.toString() == singleValue.toLowerCase().toString()
              }
            })
          }
          else {
            if (event.value.includes('Staff')) {
              return a;
            }
          }

        })
        console.log("sortedList", sortedList);
        temp = temp.concat(sortedList)
        // console.log("temp ========>", temp);
        let uniqueArray = temp.filter(function (item, pos) {
          return temp.indexOf(item) == pos;
        })
        this.staff = uniqueArray
        console.log("temp--- ", this.staff)
        if (this.staff.length <= 0) {
          if (event.value.includes('All')) {
            this.staff = this.staffCopy
            this.updateData(this.staffCopy)
          }
          else {
            this.afterFilter = {
              title: "No Quiz!",
              data: "Sorry, no status matched your search"
            }

          }
        }
        else if (event.value.includes('All')) {
          this.staff = this.staffCopy
        }
        this.updateData(this.staff)

      });
    }
    else {
      this.staff = this.staffCopy
      this.updateData(this.staffCopy)
    }
  }

  updateData(instructors) {
    console.log("UPDATING DATA = ", instructors)
    this.dataSource = new MatTableDataSource(instructors);
    this.dataSource.sortingDataAccessor = (item, property) => {
      // console.log("item=====>>>>>", item);
      // console.log("property=====>>>>>", property);

      switch (property) {
        case 'role':
          return item.userId.userRole;
        case 'name': return item.name;
        case 'dateOfJoining': return item.dateOfJoining
        // case
        // break;

        default:
          break;
      }
    }
    // this._cd.detectChanges()
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this._cd.detectChanges()
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    // this.paginator._changePageSize(instructors.length)

  }


  tabChanged(event) {
    console.log("Tab changed", event);
    this.selectedTab = event.index;
    if (this.selectedTab === 0) {
      // this.displayedColumns = ['name', 'dateOfJoining', 'role', 'sponsertype', 'competency', 'actions'];
      this.updateData(this.staff)
    } else {
      // this.displayedColumns = ['name', 'actions']
      // this.displayedPendingUsersColumns.forEach((column) => {
      //   console.log("COLUMN", column)
      //   this.sort.register(column)
      //   // const sortable = this.sort.sortables.get(column);
      //   // console.log("WHAT IS IN THE SORTABLE", sortable)
      // })
      this.updateData(this.pendingUserList)
    }
    this.updateQueryParams({ currentTab: this.selectedTab })

    console.log("SELECTED TAB INDEX", this.selectedTab)
  }

  viewPendingUser(user) {
    this.pendingUserData = user
    console.log("VIEW SINLGE USER DATA", this.pendingUserData)
    this._isDisplay = true
  }

  closeForm(event) {
    this.pendingUserData = null
    this._isDisplay = false
  }


  approveOrRejectEvent(event) {
    console.log("EVENT OF APPROVE OR REJECT", event)
    if (event === 'approve') this.approveUser(this.pendingUserData)
    if (event === 'reject') this.notApprovedUser(this.pendingUserData)
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  goToSingleInstructor(instructor) {
    let NavigationExtras: NavigationExtras = {
      state: {
        instructor: instructor,
      }
    };
    this.router.navigateByUrl('/staff/view/' + instructor._id)
  }

  archiveStaff(event, staff) {
    if (event.checked) this.multipleStaffArchive.push(staff._id)
    else {
      this.multipleStaffArchive.splice(this.multipleStaffArchive.findIndex(a => a === staff._id), 1)
    }
    console.log("MULTIPLE STAFF DELETED STAFF LIST", this.multipleStaffArchive)
  }

  archiveMultipleStaff() {
    // let isArchiveStaff = true
    let content
    if (this.showArchived) content = 'Unarchive'
    else content = 'Archive'
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, { isArchiveStaff: true, content: content }).afterClosed().subscribe((res) => {
      console.log("RESPONSE OF ARCHIVE STAFF", res)
      if (res == undefined) {
        this.manageCheckList()
        return res
      }
      else if (res === 'yes') {
        console.log("STAFF SHOULD BE ARCHIVED")
        this.archivedMultipleStaff()
      } else {
        console.log("NO ACTION OCCURED")
        this.manageCheckList()
      }
    })
  }

  archiveChange(event) {
    console.log("WHAT IS IN THE EVENT", event)
    if (this.showArchived) {
      this.updateData(this.archiveStaffList)
      this.noDataMsg = {
        title: "No Staff!",
        data: "There is no archive staff user!"
      }
    }
    else {
      this.updateData(this.staff)
      this.noDataMsg = {
        title: "No Staff!",
        data: "You have not yet added any staff members"
      }
    }
  }

  manageCheckList() {
    let myCheckboxes = this.myCheckboxes.toArray();
    console.log("mycheckboxeslist==========>", myCheckboxes)
    let len = myCheckboxes.length;
    for (let i = 0; i < len; i++) {
      myCheckboxes[i].checked = false;
      console.log("my checked value=======>", myCheckboxes[i].checked)
    }
    this.multipleStaffArchive = []
  }


  updateQueryParams(obj) {
    this.location.replaceState(
      this.router.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        {
          relativeTo: this.activatedRoute, queryParams: obj
        }
      ).toString()
    );
  }

  // API CALLS

  getStaff() {
    let that = this;
    this.archiveStaffList = []
    this.archiveStaffListCopy = []
    this.staff = []
    this.staffCopy = []
    this._staffService.getAllStaff().subscribe((res) => {
      console.log("===instructorsinstructorsinstructorsinstructors===", res.data.instructors)
      let newStaffArray = res.data.instructors.filter((a) => {
        if (a.isDelete == false && (!a.isArchive || a.isArchive == false)) {
          return a
        }
        if (a.isArchive == true) {
          this.archiveStaffList.push(a)
          this.archiveStaffListCopy.push(a)
        }
      })
      this.systemDate = res.systemDate
      console.log("what is the new array for staff", this.archiveStaffList);
      this.staff = newStaffArray;
      this.staffCopy = newStaffArray
      this.loading = false;
      this.updateData(newStaffArray)
    });
  }


  getPendingUsers(flag?) {
    // this.loading = true;
    this._staffService.getPendingUserList().subscribe((instructors) => {
      console.log("===instructorsinstructorsinstructorsinstructors===", instructors)
      // console.log("what is the new array for staff", newStaffArray);
      this.pendingUserList = instructors;
      this.pendingUserListCopy = instructors
      if (flag) {
        this.updateData(this.pendingUserList)
      }
      // this.displayedColumns = ['name', 'actions'];
      // this.loading = false;
      // this.isPending = true
      // this.updateData(instructors)
    });
  }

  getStaffUsers() {
    this.isPending = false
    this.displayedColumns = ['name', 'dateOfJoining', 'role', 'competency', 'actions'];

    this.updateData(this.staff)
  }

  approveUser(element) {
    console.log("when user is approved", element);
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, { isArchiveStaff: true, content: 'approve' }).afterClosed().subscribe((res) => {
      console.log("RESPONSE OF ARCHIVE STAFF", res)
      if (res === undefined) return
      if (res === 'yes') {
        this.loading = true;
        this._staffService.approvedPendingUser(element._id).subscribe((instructors) => {
          console.log("===instructorsinstructorsinstructorsinstructors===", instructors.data)
          let index = _.findIndex(this.pendingUserList, function (o) { return o._id == element._id })
          this.pendingUserList.splice(index, 1)
          instructors.data.userId = {
            userRole: ['operative']
          }
          this.staff.push(instructors.data)
          console.log("STAFF DATA TO BE LIST", this.staff)
          // this.displayedColumns = ['name', 'actions'];
          this.loading = false;
          this._isDisplay = false
          // this.isPending = true
          this.updateData(this.pendingUserList)
          this._utilityService.openSnackBar('User Approved Successfully', 'Ok')
        }, (error) => {
          console.log("approve users some error occure ", error)
          this.loading = false
          this._isDisplay = false
        });
      }
    })
  }

  notApprovedUser(instructor) {
    let obj = {
      documentId: instructor._id
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, { _isStaffReject: true, content: 'reject' }).afterClosed().subscribe((res) => {
      if (res === undefined) return
      if (res === 'yes') {
        this.loading = true
        this._staffService.removedOperativeUser(JSON.stringify(obj)).subscribe((instructors) => {
          console.log("user rejected", instructors)
          let index = _.findIndex(this.pendingUserList, function (o) { return o._id == instructor._id })
          this.pendingUserList.splice(index, 1)
          this._isDisplay = false
          this.loading = false
          this.updateData(this.pendingUserList)
          this._cd.detectChanges()
          this._utilityService.openSnackBar('User Rejected Successfully', 'Ok')
        }, error => {
          console.log("some error occured while rejecting user ", error)
          this.loading = false
        });
      }
    })
  }

  openModal(competencies) {
    console.log("here is the array  =====>", competencies);
    let data = {
      competencies: competencies,
      systemDate: this.systemDate
    }

    let competency = this._utilityService.commonDialogBoxOpen(CompetencyDetailModalComponent, data);
  }

  // Archive multiple staff
  archivedMultipleStaff() {
    this.loading = true
    console.log("RMEOVED STAFF LIST", this.multipleStaffArchive)
    this._staffService.archiveMultipleStaff({ staff: this.multipleStaffArchive, status: this.showArchived ? false : true }).subscribe((res) => {
      // this.loading = true
      this.getStaff()
      this._utilityService.handleSnackBar({ msg: `Staff has been ${this.showArchived ? 'Unarchive' : 'Archive'} successfully`, button: "Ok" });
      this.manageCheckList()
      this.showArchived = false
    }, error => {
      console.log("error while archive staff", error)
      this.loading = false
    })
  }


  downloadSponsorPack(data) {
    this.isSpinnerId = data._id;
    this.isSpinner = true
    console.log("DATA OF PACK", data)
    this._staffService.downloadSponsorPack(data._id, false).subscribe((res) => {
      console.log("DOWNLOAD RES", res)
      if (res) {
        const downloadLink = document.createElement("a");
        // const fileName = moment(new Date(obj.submissionDate)).format("MM-DD-YYYY") + ".pdf";
        downloadLink.href = res;
        // downloadLink.download = fileName;
        downloadLink.click();
        this._utilityService.handleSnackBar({ msg: "File downloaded successfully!", button: "Ok" })
      }
      this.isSpinner = false;
      this.isSpinnerId = null
    }, error => {
      console.log("EROR WHILE DOWNLOAD", error)
      this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
      this.isSpinner = false
      this.isSpinnerId = null
    })
  }

}
